//

type ProjectTreeNode = {
  text: string;
  projectFolder?: string;
  uniqueId?: string;
  projectStoreId?: string;
  children: ProjectTreeNode[];
  showChildren: boolean;
  type: "folder" | "project";
};

interface IProject {
  name: string;
  folder: string;
  uniqueId: string;
  projectStoreId: string;
}

const addFolder = (nodes: ProjectTreeNode[], folder: string) => {
  for (const node of nodes) {
    if (node.text === folder) {
      return node;
    }
  }
  const node: ProjectTreeNode = {
    text: folder,
    children: [],
    showChildren: true,
    type: "folder",
  };
  nodes.push(node);
  return node;
};

const addProject = (nodes: ProjectTreeNode[], project: IProject) => {
  for (const node of nodes) {
    if (node.text === project.name) {
      return node;
    }
  }

  const projectNode: ProjectTreeNode = {
    text: project.name,
    uniqueId: project.uniqueId,
    projectStoreId: project.projectStoreId,
    projectFolder: project.folder,
    children: [],
    showChildren: false,
    type: "project",
  };
  nodes.push(projectNode);
  return projectNode;
};

const createProjectTree = (projects: IProject[]): ProjectTreeNode[] => {
  const treeNodes: ProjectTreeNode[] = [];
  for (const project of projects) {
    let folderNode = undefined;
    if (project.folder) {
      const subFolders = project.folder.split("/");
      let nodes = treeNodes;
      for (const subFolder of subFolders) {
        folderNode = addFolder(nodes, subFolder);
        nodes = folderNode.children;
      }
    }
    if (folderNode) {
      addProject(folderNode.children, project);
    } else {
      addProject(treeNodes, project);
    }
  }
  return treeNodes;
};

const sortNodes = (nodes: ProjectTreeNode[]) => {
  nodes.sort((a, b) => {
    const aText = a.text.toUpperCase();
    const bText = b.text.toUpperCase();
    if (aText < bText) return -1;
    if (aText > bText) return 1;
    return 0;
  });
  return;
};

const sortProjectTree = (nodes: ProjectTreeNode[]) => {
  const folderNodes = [];
  const projectNodes = [];
  for (const node of nodes) {
    if (node.children.length > 0) {
      node.children = sortProjectTree(node.children);
      folderNodes.push(node);
    } else {
      projectNodes.push(node);
    }
  }
  sortNodes(folderNodes);
  sortNodes(projectNodes);
  return folderNodes.concat(projectNodes);
};

export { createProjectTree, sortProjectTree };
export type { ProjectTreeNode };
